import React, { useState, useContext } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import Logo from 'assets/img/logo-white.png';
import * as actions from '../actions';

import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';

function ForgotPassword({ forgotPass, history }) {
  const cmsContext = useContext(CmsContext);
  const [form, setForm] = useState({
    email: '',
  });
  const CMS_LOGO = cmsContext.findByType('LOGOS');

  const cmsLogo = _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl');
  const cmsLogoWhite = _.get(CMS_LOGO, 'CORE_LOGO_WHITE.cdnUrl');

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img
      src={!cmsLogoWhite ? cmsLogo : cmsLogoWhite}
      className="front-icon-logo"
      alt="Local Government System"
    />
  ) : (
    <MiniLoader />
  );

  const onChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const args = {
      email: form.email,
    };
    forgotPass(args, () => {
      history.push('/');
    });
  };

  return (
    <div className="login-page login-core login-background--core ">
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-5 mx-auto">
            <div className="login-section">
              <div className="header">
                {displayLogoImage}
              </div>
              <div className="content">
                <div className="login-box">
                  <div className="welcome-intro">
                    <h2 className="title">Forgot Your Password</h2>
                    <h4 className="description">
                      Please confirm your mobile number below and we will send
                      you a verification code.
                    </h4>
                  </div>
                  <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                      <label htmlFor="loginUsername" className="form-label">
                        Email
                      </label>
                      <input
                        className="form-control"
                        value={form.email}
                        onChange={onChange}
                        name="email"
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-success btn-block btn-forgot"
                    >
                      Confirm
                    </button>
                  </form>
                </div>
              </div>
              <div className="footer">
                <Link to="/" className="link-signup">
                  Already have an account? <strong>Login Now!</strong>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ForgotPassword.propTypes = {
  forgotPass: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateTopRops = () => ({});

export default withRouter(connect(mapStateTopRops, actions)(ForgotPassword));
